import SVGFile from 'visitor-ui-component-library-icons/icons/SVGFile';
import { EXTENSION_ICONS, FILE_TYPE_ICONS } from './constants';
export function getFileTypeIcon(mimeType, extension) {
  var _ref, _FILE_TYPE_ICONS;
  return (_ref = (_FILE_TYPE_ICONS = FILE_TYPE_ICONS[mimeType]) !== null && _FILE_TYPE_ICONS !== void 0 ? _FILE_TYPE_ICONS : extension ? EXTENSION_ICONS[extension.toLowerCase()] : undefined) !== null && _ref !== void 0 ? _ref : SVGFile;
}